import React from "react";

export function FoodIcon(): React.ReactElement {
  return (
    <svg
      display="block"
      width="27"
      height="27"
      viewBox="0 0 19 17"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 6.50001H7.16667V0.666672H8.83333V6.50001C8.83333 8.34167 7.34167 9.83334 5.5 9.83334V17.3333H3.83333V9.83334C1.99167 9.83334 0.5 8.34167 0.5 6.50001V0.666672H2.16667V6.50001H3.83333V0.666672H5.5V6.50001ZM11.3333 10.6667V4.00001C11.3333 2.53334 13.2 0.666672 15.5 0.666672V17.3333H13.8333V10.6667H11.3333Z"
      />
    </svg>
  );
}
